import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div``;

interface InputBoxProps {
	isdisable: boolean;
}

export const inputBox = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== 'isdisable' // Bloqueia a passagem de `isdisable` para o DOM
})<InputBoxProps>`
	position: relative;
	width: 100%;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	opacity: ${(props) => (props.isdisable ? '0.5' : '1')};
	> p {
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
	}
`;

export const messages = styled.div`
	position: absolute;
	bottom: 0;
	transform: translateY(110%);
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	> p {
		color: ${color.interface.lightGray};
		font-size: 1.2rem;
	}
`;

export const containerContLength = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	> p {
		color: ${color.interface.lightGray};
		font-size: 11px;
	}
`;

export const labelAndQuestionBox = styled.div`
	width: 100%;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	> p {
		min-width: 0;
		font-weight: 700;
		color: ${color.interface.lightGray};
		font-size: 1.4rem;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const inputAndBtn = styled.div<{ $paddingInLineEnd: boolean }>`
	width: 100%;
	min-width: 0;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;

	> input {
		all: unset;
		width: 100%;
		min-width: 0;
		min-height: 4.2rem;
		line-height: 1.4;
		border: 1px solid ${color.interface.lightGray2};
		padding-top: 1rem;
		padding-bottom: 1rem;
		font-family: nunito-regular;
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
		padding-inline-start: 10px;
		padding-inline-end: 10px;
		box-sizing: border-box;
		border-radius: 5px;
	}

	> input::placeholder {
		font-family: nunito-regular;
		opacity: 0.8;
		font-size: 15px;
	}

	> button {
		all: unset;
		text-align: center;
		border-radius: 5px;
		min-height: 100%;
		padding: 1.2rem 1rem;
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const errorMessage = styled.span`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	color: ${color.interface.red};
	font-size: 11px;
`;
